import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { FilterService } from '../../services/filter.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, Language } from '../../global/constants';

@Component({
  selector: 'app-admin-filter',
  templateUrl: './admin-filter.component.html'
})
export class AdminFilterComponent implements OnInit {

  loadingPage = true;
  addTrainingDialogRef: BsModalRef;
  filterData: any[] = [];

  newTraining: any = {
    k: 'n/a',
    v: ''
  };

  pages: any[] = [
    {
      type: 'from_address',
      header: 'From Address',
      help: 'Full and partial matches to these from addresses will be eliminated'
    },
    {
      type: 'subject',
      header: 'Subject',
      help: 'Full and partial matches to these subjects will be eliminated'
    },
    {
      type: 'header',
      header: 'Header',
      help: 'Header key/value pairs - full and partial matches to these will be eliminated'
    }
  ];

  currentPage: any = this.pages[0];

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private filterService: FilterService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.changePage(this.currentPage);
  }

  changePage(page: any) {
    this.currentPage = page;
    if (this.currentPage.type=='header') {
      this.newTraining.k = '';
    }
    else {
      this.newTraining.k = 'n/a';
    }
    this.refreshData();
  }

  addTraining(dialog) {
    this.addTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveTraining() {
    this.addTrainingDialogRef.hide();
    this.filterService.newTraining(this.currentPage.type, this.newTraining.k, this.newTraining.v).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training added');
        this.newTraining = {
          k: 'n/a',
          v: ''
        };
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-filter.component', 'addTraining.100');
      }
    );
  }

  deleteTraining(training) {
    this.filterService.deleteTraining(training._id).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training deleted');
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-filter.component', 'deleteTraining.100');
      }
    )
  }

  private refreshData() {
    this.loadingPage = true;
    this.filterService.getTraining(this.currentPage.type).subscribe(
      (result: any) => {
        this.filterData = result;
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-filter.component', 'refreshData.100');
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-filter/admin-filter.component.ts